import '../node_modules/bootstrap/scss/bootstrap.scss'
import "@fortawesome/fontawesome-free/css/all.css";
import {Link, Routes, Route, useNavigate, useLocation} from 'react-router-dom'

function Nav() {

  const navigate = useNavigate();

  const location = useLocation();

  const section = location.pathname.toString().split('/');

    return (
      <div className="container-fluid fullvh g-0">

        <div className="row fullvh g-0">

          <div className="col g-0 fullvh d-flex justify-center flex-column">
            <Link to="/" relative="path">
              <button className="nav-button"><i className="fa-sharp fa-solid fa-house" data-fa-mask="fa-solid fa-comment"></i></button>
            </Link>
            <button className="nav-button mt-1" onClick={() => {if (section[1] == 'conoce') {navigate('/digital')} else { navigate(-1)}}}><i className="fa-sharp fa-solid fa-arrow-left" data-fa-mask="fa-solid fa-comment"></i></button>
          </div>

        </div>

      </div>
    );


}

export default Nav;
